export default {
  isLoading: true,

  projectFolders: [],
};
